import { useNavigate } from 'react-router-dom'

import { FloraButton, Flex } from '@grupoboticario/flora-react'

import { useUserContext } from '@/context/user'
import { PlusCircle } from '@/icons/PlusCircle'
import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'

import { newAccelerationButton, newAccelerationContainer } from './styles'

const NewAcceleratorButton = ({ label }) => {
  const { hasPermission } = useUserContext()
  const navigate = useNavigate()

  return (
    <Flex align="center" css={newAccelerationContainer}>
      <FloraButton
        css={newAccelerationButton}
        disabled={!hasPermission(Actions.CREATE_ACCELERATION)}
        onClick={() => navigate('/acceleration/new')}
        has="iconLeft"
        icon={<PlusCircle />}
      >
        {label}
      </FloraButton>
    </Flex>
  )
}

export default NewAcceleratorButton
